import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { ref, computed } from "vue";
import { uploadImage } from "../api/image";
import { Plus } from "@element-plus/icons-vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { ElMessage } from 'element-plus/lib/components';
export default {
  name: "KilaKilaUploader",
  emits: ["uploaded", "aboutToUpload", "removed"],
  components: {
    Plus: Plus,
    VueEasyLightbox: VueEasyLightbox
  },
  setup: function setup(props, context) {
    var progress = ref(0);
    var isLightBoxVisible = ref(false);
    var isProgressVisible = ref(false);
    var isSuccessLabelVisible = ref(false);
    var imageUrl = ref("");
    var localImageUrl = ref("");
    var index = ref(0);
    var isThumbnailVisible = computed(function () {
      return localImageUrl.value.length > 0;
    });

    function openFileDialog() {
      document.getElementById("file-input").click();
    }

    function onImageAdded() {
      var fileInput = document.getElementById("file-input");

      if (fileInput.files.length == 0) {
        return;
      }

      context.emit("aboutToUpload");
      var file = fileInput.files[0];
      setImageUrl(URL.createObjectURL(file));
      upload(file);
    }

    function setImageUrl(url) {
      var thumbnailEl = document.getElementById("thumbnail");
      thumbnailEl.src = localImageUrl.value = url;
    }

    function handleThumbnailRemove(file) {
      imageUrl.value = "";
      localImageUrl.value = "";
      context.emit("removed", file);
    }

    function handleThumbnailPreview() {
      isLightBoxVisible.value = true;
    }

    function handleLightboxHide() {
      isLightBoxVisible.value = false;
    }

    function upload(file) {
      progress.value = 0;
      isProgressVisible.value = true;
      isSuccessLabelVisible.value = false;
      uploadImage(file, progress).then(function (url) {
        progress.value = 100;
        imageUrl.value = url;
        document.getElementById("thumbnail").src = url;
        context.emit("uploaded", url);
        setTimeout(function () {
          isProgressVisible.value = false;
          isSuccessLabelVisible.value = true;
        }, 200);
      }, function () {
        isProgressVisible.value = false;
        localImageUrl.value = "";
        context.emit("uploaded", "");
        ElMessage.error("哎呀，图片上传出错啦~");
      });
    }

    return {
      progress: progress,
      imageUrl: imageUrl,
      localImageUrl: localImageUrl,
      index: index,
      isLightBoxVisible: isLightBoxVisible,
      isThumbnailVisible: isThumbnailVisible,
      isProgressVisible: isProgressVisible,
      isSuccessLabelVisible: isSuccessLabelVisible,
      handleThumbnailRemove: handleThumbnailRemove,
      handleThumbnailPreview: handleThumbnailPreview,
      handleLightboxHide: handleLightboxHide,
      openFileDialog: openFileDialog,
      onImageAdded: onImageAdded,
      setImageUrl: setImageUrl
    };
  }
};